import { render, staticRenderFns } from "./GroupsDialog.vue?vue&type=template&id=a86aeb4c"
import script from "./GroupsDialog.vue?vue&type=script&lang=js"
export * from "./GroupsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports